import { create } from "zustand";
import { useFetchCustomerMissingDataSlice } from "../slices/CustomerMissingSlices/fetchCustomerMissingSlice";

interface CustomerMissingInterface
  extends ReturnType<typeof useFetchCustomerMissingDataSlice> {}

export const CustomerMissingStore = create<CustomerMissingInterface>((...a) => ({
  ...useFetchCustomerMissingDataSlice(...a),
}));
